import type { FC } from "react";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { BoxedSliderField } from "web_myplann/Inspiration/Components/BoxedSliderField";
import { InspirationSheet } from "web_myplann/Inspiration/Components/InspirationSheet";
import {
	OWN_HOME_EXPENSES_FALLBACK,
	OWN_HOME_EXPENSES_MAX,
	OWN_HOME_EXPENSES_MIN,
	OWN_HOME_EXPENSES_STEP,
} from "web_myplann/Inspiration/constants";
import { useResetOnOpen } from "web_myplann/Inspiration/Hooks/useResetOnOpen";

const R = Resources.Inspiration.OwnHome.ExpensesSheet;

type Props = {
	open: boolean;
	initial?: number;
	onClose: () => void;
	onSubmit: (expenses: number) => void;
	onSaveToBilance: () => void;
};

export const ExpensesSheet: FC<Props> = ({
	open,
	initial,
	onClose,
	onSubmit,
	onSaveToBilance,
}) => {
	const { t } = useResource();
	const [expenses, setExpenses] = useResetOnOpen(
		open,
		initial ?? OWN_HOME_EXPENSES_FALLBACK,
	);

	return (
		<InspirationSheet
			open={open}
			onClose={onClose}
			title={t(R.title)}
			description={t(R.description)}
			primaryLabel={t(R.submit)}
			onPrimary={() => onSubmit(expenses)}
			secondaryLabel={t(R.saveToBilance)}
			onSecondary={onSaveToBilance}
		>
			<BoxedSliderField
				label={t(R.expensesLabel)}
				value={expenses}
				onChange={setExpenses}
				min={OWN_HOME_EXPENSES_MIN}
				max={OWN_HOME_EXPENSES_MAX}
				step={OWN_HOME_EXPENSES_STEP}
			/>
		</InspirationSheet>
	);
};
